import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Check / tick — always visible. On mount, the stroke "draws in" from
 *  the bottom-left corner to the upper-right tip (SMIL, fill=freeze so
 *  it stays drawn). The `active` prop is an optional replay trigger:
 *  flipping it to true re-keys the <animate> so the flourish plays again.
 *  It does NOT hide the glyph — an empty checkmark tile would be confusing. */
export function IcnCheck(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const reduced = useReducedMotion();
  return (
    <Svg {...rest} iconName="check" data-on={active ? 'true' : 'false'}>
      <path d="M3 8.5l3 3 7-7" strokeDasharray="15" strokeDashoffset="0">
        {!reduced && (
          <animate
            key={active ? 'on' : 'off'}
            attributeName="stroke-dashoffset"
            from="15"
            to="0"
            dur="0.45s"
            fill="freeze"
          />
        )}
      </path>
    </Svg>
  );
}
